import { Button } from 'lego-on-react';
import block from 'propmods';
import React, { FC, useState } from 'react';
import * as keyset from 'i18n/GeneralSettings';
import i18n from '@yandex-int/i18n';
import { newsSubscribe, newsUnsubscribe, subscribe, unsubscribe } from '../../api';
import { CheckboxField, Header } from '../Form/Form';
import { spamAgreenemt } from '../../lib/gdpr-texts';

import './GeneralSettings.scss';

const b = block('GeneralSettings');
const t = i18n(keyset);

const GeneralSettings: FC = () => {
    const [isUpdating, setIsUpdating] = useState(false);
    const [isError, setIsError] = useState(false);
    const [hasSubscription, setHasSubscription] = useState(__appConfig.user.hasSubscription);
    const [hasNewsSubscription, setHasNewsSubscription] = useState(__appConfig.user.hasNewsSubscription);

    const onSubscriptionChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
        setHasSubscription(e.currentTarget!.checked);
        setIsError(false);
    };
    const onNewsSubscriptionChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
        setHasNewsSubscription(e.currentTarget!.checked);
        setIsError(false);
    };

    const onSave = async () => {
        if (isUpdating) {
            return;
        }

        setIsError(false);
        setIsUpdating(true);

        try {
            if (__appConfig.user.hasSubscription !== hasSubscription) {
                const handler = hasSubscription ? subscribe : unsubscribe;
                await handler();
                __appConfig.user.hasSubscription = hasSubscription;
            }
            if (__appConfig.user.hasNewsSubscription !== hasNewsSubscription) {
                const handlerNews = hasNewsSubscription ? newsSubscribe : newsUnsubscribe;
                await handlerNews();
                __appConfig.user.hasNewsSubscription = hasNewsSubscription;
            }
        } catch (_e) {
            setIsError(true);
        } finally {
            setIsUpdating(false);
        }
    };
    // ТЕКСТЫ ЧЕКБОКСОВ МЕНЯТЬ ТОЛЬКО ПО СОГЛАСОВАНИЮ!!!
    return (
        <div {...b()}>
            <div {...b('main')}>
                <Header title={t('header-email')} />
                <CheckboxField checked={hasSubscription} disabled={isUpdating} onChange={onSubscriptionChange}>
                    {t('checkbox-notifications')}
                </CheckboxField>
                <div style={{ marginTop: '-20px' }}>
                    <CheckboxField
                        checked={hasNewsSubscription}
                        disabled={isUpdating}
                        onChange={onNewsSubscriptionChange}
                    >
                        {t('checkbox-global-message')}
                    </CheckboxField>
                    <div {...b('argeenemt')}>{spamAgreenemt}</div>
                </div>
            </div>
            <div {...b('footer')}>
                <Button theme="action" size="s" disabled={isUpdating} onClick={onSave} progress={isUpdating}>
                    {t('button-save')}
                </Button>
                {isError && <span {...b('error')}>{t('error')}</span>}
            </div>
        </div>
    );
};

export default GeneralSettings;
